import React, { Component } from "react";
import _ from "lodash";
import { List, Progress } from "semantic-ui-react";
import Dropzone from "react-dropzone";
import { uploadFile } from "../../firebase";

class MultiDrop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progress: 0,
      files: [],
    };
  }

  findKey(image, file, index) {
    //console.log("image, file, index", image, file, index);
    let arr = this.state.files;
    let width = image.offsetWidth,
      height = image.offsetHeight;
    const size = `${width}x${height}`;
    //console.log("size:", width, height, size);
    const key = _.findKey(this.props.fileKeys, (obj) => {
      return _.indexOf(obj, size) !== -1;
    });
    //console.log(key);
    arr[index].dimensions = size;
    if (key) {
      this.props.change(key, { path: image.src, name: file.name, size: size });
    } else {
      arr[index].warning = true;
    }
    this.setState({ files: arr });
  }

  onDrop(files) {
    let arr = [];
    let { folder } = this.props;
    files.forEach((file, index) => {
      uploadFile(file, folder, (data) => {
        //console.log("upload file data", data);
        if (data.error) {
          let file = { ...this.state.files[index], warning: true };
          arr[index] = file;
          this.setState({ files: arr });
        } else {
          arr[index] = data;
        }
        this.setState({ files: arr });
      });
    });
  }

  onCancel() {
    this.setState({
      files: [],
    });
  }

  onImgLoad({ target: img }, file, index) {
    this.findKey(img, file, index);
  }

  render() {
    const { files } = this.state;
    return (
      <div className="drop-zone">
        <Dropzone onDrop={this.onDrop.bind(this)}>
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className="drop-box">
              <input {...getInputProps()} />
              <p>Drop files here, or click to select files</p>
            </div>
          )}
        </Dropzone>
        <List divided relaxed>
          {files &&
            files.map((file, index) => (
              <List.Item
                key={file.name}
                className={file.warning ? "warning" : ""}
              >
                <List.Content>
                  {file.path && (
                    <span className="drop-thumbnail">
                      <img
                        src={file.path}
                        onLoad={(e) =>
                          this.onImgLoad.bind(this)(e, file, index)
                        }
                        alt="thumbnail"
                      />
                    </span>
                  )}
                  {file.warning && (
                    <span className="thumbnail">
                      <img src={file.path} alt="thumbnail" />
                    </span>
                  )}
                  <List.Header as="h4">
                    {file.name} {file.dimensions && `(${file.dimensions})`}
                  </List.Header>
                  <List.Description>
                    <Progress
                      percent={file.progress}
                      size="small"
                      autoSuccess
                      warning={file.warning}
                    />
                    {file.progress === 100 && <span>upload complete</span>}
                    {file.warning && (
                      <span className="warning-message">
                        Error: file size too large or wrong dimensions
                      </span>
                    )}
                  </List.Description>
                </List.Content>
              </List.Item>
            ))}
        </List>
      </div>
    );
  }
}

export default MultiDrop;
